import { DataDownloadMessages } from '../types';

export const dataDownloadSW: DataDownloadMessages = {
  'app.datadownload.checkbox.study_abroad': 'Jifunze nje ya nchi',
 'app.datadownload.checkbox.additional_demographics_info': 'Demografia ya ziada',
 'app.datadownload.checkbox.remove_anonymous_user': 'Ondoa watumiaji wasiojulikana',
}
